// Attribute
import attribute from '@drivesally/sally-fn/lib/attribute/attribute';
import type from '@drivesally/sally-fn/lib/types/type';

// Input types
import {TEXT, NUMBER, DATE, DATETIME, SWITCH} from '@drivesally/sally-fn/lib/inputTypes';

// Types
import {string, number, date, dateTime} from '@drivesally/sally-fn/lib/types';

// Gas field values are booleans, not the 'yes'/'no' strings sally-fn's own
// explicitSwitch type expects, and there's no other read-only yes/no type
// upstream - so this constructs one locally via the same type() factory
// sally-fn's own types use, rather than adding a bespoke display component.
const yesNo = type({
  type: 'boolean',
  format: (value) => (value ? 'Yes' : 'No'),
  validate: () => true,
});

const TYPE_CONFIG = {
  text: {inputType: TEXT, typeFn: string},
  number: {inputType: NUMBER, typeFn: number},
  date: {inputType: DATE, typeFn: date},
  datetime: {inputType: DATETIME, typeFn: dateTime},
  boolean: {inputType: SWITCH, typeFn: yesNo},
};

// Builds a sally-fn "attribute" (the same object shape @drivesally/sally-fn's
// attribute() factory produces for every hand-authored *.attribute.*.js file
// elsewhere in this app) for an arbitrary Gas field, driven entirely by the
// {field, label, type} descriptor the backend serializes on section_field_meta.
const dynamicFieldAttribute = ({field, label, type: fieldType} = {}, value) => {
  const {inputType, typeFn} = TYPE_CONFIG[fieldType] || TYPE_CONFIG.text;
  return attribute({
    type: inputType,
    attribute: field,
    display: typeFn,
    input: typeFn,
    api: typeFn,
    label: {default: label, short: label},
  })(value);
};

export default dynamicFieldAttribute;
